__webpack_require__.p = "https://www.eurekaforbes.com/cms/assets/web/e0f6aa8/_next/";